<template>
    <sa-page-layout :btnBackVisible="true" :btnEditVisible="false" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading" :btnPrintVisible="false" :linkPrintData="linkPrintData">
        <template slot="toolbar"> </template>
        <template slot="table-body">
            <flussi-view-component ref="cmpFlussiView" @beforeLoadData="onBeforeloadData" @afterLoadData="onAfterLoadData"></flussi-view-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
// import PrintComponent from "../../../utility/components/PrintComponent.vue";
import FlussiViewComponent from "../components/FlussiViewComponent.vue";

export default {
    components: { SaPageLayout, FlussiViewComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            btnNewVisible: false,
            pathResource: "/rsaaccettazioni",
            id: null,
            btnEditVisible: true,
            linkedit: null,
            linkback: "/flussi",
            linkPrintData: "",
            showModalLoading: false,
            listKey: 0,
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.linkedit = "/rsaaccettazione/edit/" + me.id;
        me.linkPrintData = "/rsaaccettazioni/print/" + me.id;
        this.$refs.cmpFlussiView.setId(me.id);
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeloadData() {
            let me = this;
            me.showModalLoading = true;
        },
        loadStampeReport() {
            let me = this;
            // me.printData = {};

            me.loadDataResources(me.pathResource + "/printdata/" + me.id, null, me.resultResponseStampa, me.resultErrorStampa);
        },
        resultResponseStampa(response) {
            let me = this;
            me.reportName = response.data.data.reportName;
            me.printData = response.data.data;

            me.$refs.cmpPrint.print(response.data.data);
        },
        resultErrorStampa(error) {
            console.log(error);
        },
    },
};
</script>
<style></style>
